import template from './time_view.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';
import * as Navbar from '../../lib/update_navbar_notifications.js';

class TimeViewViewModel
{
	constructor(page)
	{
		this.page = page;
		this.loader = ko.observable(false);
		this.time_logged_report = ko.observableArray([]);
		this.task_summary_report = ko.observableArray([]);
		this.manager = ko.observableArray([]);
		this.employee_id = ko.observable();
		let fromDate = new Date();
		fromDate.setDate(1);
		this.from_filter = ko.observable(Utils.toJSONDateString(fromDate));
		this.to_filter = ko.observable(Utils.toJSONDateString(new Date()));
		this.page_title = ko.observable();

		this.selected_display = ko.observable('time_logged_rg');
		this.selected_search = ko.observable('employee_rg');

		this.summary_total_hours = ko.observable(0);
		this.summary_employees_count = ko.observable(0);
		this.table_visible = ko.observable(false);
		this.other_employee_page = ko.observable(false);

		this.from_filter.subscribe((d) => {
			if (d > this.to_filter())
				this.to_filter(d);
		});

		this.to_filter.subscribe((d) => {
			if (d < this.from_filter())
				this.from_filter(d);
		});
	}

	async view_entry(row)
	{
		console.log('View entry clicked', row); // Add logging
    	console.log('Employee ID:', this.employee_id()); // Log employee ID
		row.view_only = true;
		await Grape.dialog.open('LogTime', { row: row, employee_id: this.employee_id() });
		this.page.updateData();
	}

	async resubmit_entry(row)
	{
		row.resubmit = true;
		await Grape.dialog.open('LogTime',{ row: row, employee_id: this.employee_id() });
		this.page.updateData();
	}

	show_report_help()
	{
		Grape.dialog.open('TimeViewHelp', { employee_id: this.page.bindings.id });
	}

	async log_time()
	{
		Utils.refresh_data_visible_roles();
		await Grape.dialog.open('LogTime', { employee_id: this.employee_id() });
		this.page.updateData();
	}

	async import_time()
	{
		Utils.refresh_data_visible_roles();
		await Grape.dialog.open('AdminImportTime', {});
		this.page.updateData();
	}

	async log_time_employee()
	{
		Utils.refresh_data_visible_roles();
		await Grape.dialog.open('LogTimeEmployee', { employee_id: Utils.current_employee_id(), log_time_employee: this.employee_id() });
		this.page.updateData();
	}

	async delete_entry(row)
	{
		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr("Are you sure you want to delete the entry?")});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/time_management/remove_task_time', { task_time_id: row.task_time_id });
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully removed time logged entry.') , title: tr('Success') });
				this.page.updateData();
			}
			else if (res.status == 'ERROR')
			{
				Grape.alerts.apiError(res);
				this.page.updateData();
			}
			else if (res.error)
			{
				Grape.alerts.alert({ type: 'error', message: res.error, title: tr('Error') });
				this.page.updateData();
			} else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		}
	}

	async edit_entry(row)
	{
		await Grape.dialog.open('LogTime', { row: row , employee_id: this.employee_id() });
		this.page.updateData();
	}
}

class TimeViewPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new TimeViewViewModel(this);
	}

	init()
	{
		if (this.bindings.employee_name)
		{
			document.title = tr('Log time for ' + this.bindings.employee_name);
			window.current_page_title(tr('Log Time For ' + this.bindings.employee_name));
			this.viewModel.page_title(tr('Log Time For '+ this.bindings.employee_name));
		}
		else 
		{
			document.title = tr('My logged time');
			window.current_page_title(tr('My Logged Time'));
			this.viewModel.page_title(tr('My Logged Time'));
		}

		if (this.bindings.employee_id)
		{
			this.viewModel.employee_id(this.bindings.employee_id);
			this.viewModel.other_employee_page(true);
		}
		else
			this.viewModel.employee_id(Utils.current_employee_id());

		this.load_entries();
	}

	updateData()
	{
		this.load_entries();
	}

	async load_entries()
	{
		this.viewModel.loader(true);
		await Navbar.updateTimeToApproveCount();

		const query_options = {
			employee_id: this.viewModel.employee_id(),
			start_date: this.viewModel.from_filter(),
			end_date: this.viewModel.to_filter()
		};

		if (this.viewModel.selected_display() === 'time_logged_rg') 
			await this.loadTimeTable(query_options);
		else if (this.viewModel.selected_display() === 'tasks_summary_rg') 
			await this.loadTasksTable(query_options);

		this.viewModel.loader(false);
	}

	async loadTasksTable(query_options)
	{
		let res = await Grape.fetches.postJSON('/time_management/get_task_summary', query_options);
		if (res.report.time_logged != null)
		{
			this.viewModel.summary_total_hours(res.report.total_hours);
			this.viewModel.summary_employees_count(res.report.total_employees);
			this.viewModel.task_summary_report(res.report.time_logged);
			this.viewModel.table_visible(true);
		}
		else
		{
			this.viewModel.task_summary_report([]);
			this.viewModel.table_visible(false);
		}
	}

	async loadTimeTable(query_options)
	{
		let res = await Grape.fetches.postJSON('/time_management/get_time_logged_report', query_options);
		console.log('time logged res', res);
		if (res.report.time_logged != null)
		{
			let processed_entries = res.report.time_logged.map(entry => ({
				...entry,
				start_time: Utils.get_timestamp(new Date(entry.start_time)),
				end_time: entry.end_time ? Utils.get_timestamp(new Date(entry.end_time)) : null
			}));

			this.viewModel.summary_total_hours(res.report.total_hours);
			this.viewModel.summary_employees_count(res.report.total_employees);
			this.viewModel.time_logged_report(processed_entries);
			this.viewModel.table_visible(true);
		}
		else
		{
			this.viewModel.time_logged_report([]);
			this.viewModel.table_visible(false);
		}
	}
}

export default {
	route: '[/]time_management/time_view',
	page_class: TimeViewPage,
	template: template,
	template_filename: 'translation/time_view'
};
